import React from "react";
import Base from "../layout/BaseTemplate"
import { Card, Row, Col } from "react-bootstrap";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { prism } from 'react-syntax-highlighter/dist/esm/styles/prism';
import globus_personal from "./globus_personal.png";
import endpoint from "./endpoint.png"
import Zoom from 'react-medium-image-zoom'

export default function Downloads() {
    return (
        <Base>
            <Card border="0" className="mb-4 shadow-sm rounded-4">
                <Card.Body>
                    <h1 className="display-5 mb-3">Download Reaction Libraries</h1>
                    <p className="lead">Choose one of the two options below to download the libraries.</p>
                </Card.Body>
            </Card>
            <Row>
                <Col md={6} className="mb-4">
                    <Card className="shadow-sm rounded-4">
                        <Card.Header className="bg-primary text-white rounded-top-4">
                            <h3 className="centerText">Rsync (Command Line)</h3>
                        </Card.Header>
                        <Card.Body>
                            <ol>
                                <li>
                                    List Directories Available
                                </li>
                                <ul>
                                    <li>
                                        <SyntaxHighlighter
                                            language="bash"
                                            style={prism}
                                            customStyle={{
                                                borderRadius: '0.5rem',
                                                padding: '1rem'
                                            }}
                                        >
                                            {`rsync --list-only rsync://files.docking.org/chemistrycommons/`}
                                        </SyntaxHighlighter>
                                    </li>
                                    <li>
                                        Output:
                                        <SyntaxHighlighter
                                            language="text"
                                            style={prism}
                                            customStyle={{
                                                borderRadius: '0.5rem',
                                                padding: '1rem'
                                            }}
                                        >
                                            {`drwxr-xr-x              8 2025/04/25 11:26:50 .
-rwxrwxrwx          1,275 2025/04/25 14:11:20 HEADER.html
drwxrwxrwx             54 2025/05/21 06:28:10 BB
drwxr-xr-x              4 2025/04/24 15:53:32 Enumerated
drwxrwxrwx             10 2025/04/05 11:19:29 Fe
drwxrwxrwx              3 2025/04/05 11:27:37 Ir
drwxrwxrwx             15 2025/04/15 15:21:27 tutorials`}
                                        </SyntaxHighlighter>
                                    </li>
                                </ul>

                                <li>
                                    Check Inside a Directory
                                </li>
                                <ul>
                                    <li>
                                        <SyntaxHighlighter
                                            language="bash"
                                            style={prism}
                                            customStyle={{
                                                borderRadius: '0.5rem',
                                                padding: '1rem'
                                            }}
                                        >
                                            {`rsync --list-only rsync://files.docking.org/chemistrycommons/BB/`}
                                        </SyntaxHighlighter>
                                    </li>
                                    <li>
                                        Output:
                                        <SyntaxHighlighter
                                            language="text"
                                            style={prism}
                                            customStyle={{
                                                borderRadius: '0.5rem',
                                                padding: '1rem'
                                            }}
                                        >
                                            {`drwxrwxrwx             54 2025/05/21 06:28:10 .
-rw-r--r--     14,177,700 2025/04/22 12:27:47 1-CSeconstock.smi
-rw-r--r--     25,907,502 2025/05/21 01:25:14 1-CSeconstock.smi.atdb
-rwxr--r--     41,128,226 2025/05/21 03:12:28 1-CSeconstock.smi.atdb.fp
-rw-r--r--     11,699,336 2025/05/21 01:25:15 1-CSeconstock.smi.atfp
-rw-r--r--      3,884,950 2025/04/17 09:54:14 1-CSeconstock.smi.gz
-rw-r--r--        218,137 2025/05/21 01:25:15 1-CSeconstock.smi_log
...`}
                                        </SyntaxHighlighter>
                                    </li>
                                </ul>

                                <li>
                                    How To Download
                                </li>
                                <ul>
                                    <li>
                                        Download single files:
                                        <SyntaxHighlighter
                                            language="bash"
                                            style={prism}
                                            customStyle={{
                                                borderRadius: '0.5rem',
                                                padding: '1rem'
                                            }}
                                        >
                                            {`rsync rsync://files.docking.org/chemistrycommons/BB/1-CSeconstock.smi .`}
                                        </SyntaxHighlighter>
                                    </li>
                                    <li>
                                        Download an entire directory:
                                        <SyntaxHighlighter
                                            language="bash"
                                            style={prism}
                                            customStyle={{
                                                borderRadius: '0.5rem',
                                                padding: '1rem'
                                            }}
                                        >
                                            {`rsync -L -a -m --progress rsync://files.docking.org/chemistrycommons/BB/ BuildingBlocks/`}
                                        </SyntaxHighlighter>
                                    </li>
                                    <li>
                                        Download a list of specific files inside a directory:
                                        <SyntaxHighlighter
                                            language="bash"
                                            style={prism}
                                            customStyle={{
                                                borderRadius: '0.5rem',
                                                padding: '1rem'
                                            }}
                                        >
                                            {`rsync -L -a -m --progress --include="*.smi" --exclude="*" rsync://files.docking.org/chemistrycommons/BB/ BB_smiles/`}
                                        </SyntaxHighlighter>
                                    </li>
                                </ul>
                                <li>
                                    Notes
                                </li>
                                <ul>
                                    <li>
                                        <SyntaxHighlighter
                                            language="text"
                                            style={prism}
                                            customStyle={{
                                                borderRadius: '0.5rem',
                                                padding: '1rem'
                                            }}
                                        >
                                            {`-L: transform symbolic links into referent file/directory
-a: archive mode, which preserves time stamps, 
    performs a recursive copy, 
    keeps all file and directory permissions, 
    preserves owner and group information, and copies any symbolic links.
-m: Skips empty directories
--progress: Shows progress during file transfer
--include=”PATTERN”: includes files that are of the same pattern as “*.smi”
--exclude=”PATTERN”: excludes everything that isn’t “*.smi”`}
                                        </SyntaxHighlighter>
                                        You can check what files you can download by excluding the destination folder and removing the “include” and “exclude” options.
                                        <br />
                                        You can also use "--dry-run" to simulate what you're about to download.
                                    </li>
                                </ul>
                            </ol>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6} className="mb-4">
                    <Card className="shadow-sm rounded-4">
                        <Card.Header className="bg-success text-white rounded-top-4">
                            <h3 className="centerText">Globus Personal</h3>
                        </Card.Header>
                        <Card.Body>
                            <ol>
                                <li>
                                    Create an account to log in to Globus. There are a couple ways:
                                </li>
                                <ul>
                                    <li><a href="https://app.globus.org/">Use an Organization's Login</a></li>
                                    <ul>
                                        <li>
                                            If you are associated to an organization in the drop down list, you can use your organization's login to create an account.
                                        </li>
                                        <li>
                                            You can also sign up using a Google account or ORCiD ID
                                        </li>
                                    </ul>
                                    <li>
                                        <a href="https://www.globusid.org/create">Create a Globus ID</a>
                                    </li>
                                </ul>
                                <li>
                                    Install and Create a Globus Personal Endpoint
                                </li>
                                <ol>
                                    <li>Log in.</li>
                                    <li>On the left side of the page, click the "COLLECTIONS" button on the navigation bar.</li>
                                    <li>Then, on the top right, click "Get Globus Connect Personal".</li>
                                    <li>Download based on your Operating System.</li>
                                    <li>Execute the file and follow the on screen install instructions.</li>
                                    <li>Double check that your collection is available by going to "COLLECTIONS" then to "Administered By You" which is on the top middle of the page.</li>
                                    <Zoom>
                                        <img src={globus_personal} alt="Globus Personal Setup Screenshot" className="img-fluid" />
                                    </Zoom>
                                </ol>
                                <li>
                                    Once you have your endpoint, go back to the file manager tab on the navigation bar to begin file transfer.
                                </li>
                                <ol>
                                    <li>Click on the collection input box on the left panel and then click the "Your Collections" tab.</li>
                                    <li>Choose the collection that you made.</li>
                                    <li>Next, on the right panel, click on the collection input box and type in <b>UCSF BKS Lab Guest Collection</b></li>
                                    <li>Click on the <b>UCSF BKS Lab Guest Collection</b>.</li>
                                    <li>Now both panels are ready to transfer files to and from.</li>
                                    <li>Drag and drop files/folders OR Choose a file or folder and click the blue start button at the bottom.</li>
                                    <Zoom>
                                        <img src={endpoint} alt="UCSF BKS Endpoint" className="img-fluid" />
                                    </Zoom>
                                </ol>
                            </ol>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Base >
    )
}